import { createBarStore } from './createBarStore';

export interface VendorBookingsBarState {
  archived: boolean;
  /** '' = every status. */
  status: string;
  /** '' = every vendor. */
  vendor: string;
  vendorOptions: ReadonlyArray<{ value: string; label: string }>;
  /** The open booking (booking page). */
  editor: { canSave: boolean; saving: boolean; dirty: boolean; archived: boolean; canEdit: boolean };
}

export const NO_BOOKING_EDITOR: VendorBookingsBarState['editor'] = {
  canSave: false, saving: false, dirty: false, archived: false, canEdit: false,
};

const store = createBarStore<VendorBookingsBarState>({
  archived: false, status: '', vendor: '', vendorOptions: [], editor: NO_BOOKING_EDITOR,
});

export const getVendorBookingsBar = store.get;
export const setVendorBookingsBar = store.set;
export const resetVendorBookingsBar = store.reset;
export const useVendorBookingsBar = store.use;

/** Bar -> list: open the "new booking from a quote" picker. */
export const BOOKINGS_NEW_EVENT = 'vendor-bookings:new';
/** Bar -> booking page. */
export const BOOKING_SAVE_EVENT = 'vendor-booking:save';
export const BOOKING_ARCHIVE_EVENT = 'vendor-booking:archive';
export const BOOKING_RESTORE_EVENT = 'vendor-booking:restore';
